import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params } from '@angular/router';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';

import {Title} from '@angular/platform-browser';
import {FormBuilder, Validators} from "@angular/forms";
import { ActivityService } from '../../common/activity.service';
import {ListingService } from '../listing.service';

@Component({
  selector: 'app-cancel-attendee',
  templateUrl: './cancel-attendee.component.html',
  styleUrls: ['./cancel-attendee.component.css', '../../app.component.css', '../admin.css'],
  providers: [ListingService,ActivityService]
})
export class CancelAttendeeComponent implements OnInit {

  attendeeId : any;
  userId : any;
  eventId :any;
  activityInfoArray: any;
  errorMessage : any;
  attCancelForm: any;
  spinner: boolean = false;
  payable:any;
  eventUserId:any;
  eventUserIdMain:any;


  constructor(private router: Router, public dialogRef: MdDialogRef<CancelAttendeeComponent>, private snackBar: MdSnackBar,private formBuilder: FormBuilder, private ListingService: ListingService,private ActivityService: ActivityService) {
    this.attCancelForm = this.formBuilder.group({
      "comment": ['', Validators.required],
      "attendeeId": [''],
      "userId": [''],
      "eventUserId": [''],
      "eventUserIdMain":[''],
      "eventId":[''],
      "payable":[''],
    });
  }

  ngOnInit() {
    if(this.eventId && this.userId && this.attendeeId){
      this.getActivityInfo(this.eventId,this.userId,this.attendeeId);
    }else{
      this.router.navigate(['./admin-event-listing']);
    }

  }

  getActivityInfo(eventId,userId,attendeeId){
    this.spinner = true;
    this.ListingService.getActivityInfo({eventId:eventId,userId:userId,attendeeId:attendeeId,eventUserId:this.eventUserId}).subscribe(
            response => {
      	      this.spinner = false;
              this.activityInfoArray = response;
        },
            error => {
      		this.spinner = false;
		this.errorMessage = <any>error;
	}
    );
  }

  total(){
   var price=0;var actPrice=0; var otherPrice=0;
    if(this.activityInfoArray.activity[0].price)
      actPrice = parseFloat(this.activityInfoArray.activity[0].price);

    if(this.activityInfoArray.otherPrice)
      otherPrice=parseFloat(this.activityInfoArray.otherPrice)

      price=+actPrice + +otherPrice;

      return price.toFixed(2);
  }

  cancelAttendee(){
    this.spinner = true;
    var val=(this.payable)?this.payable:0;
    this.attCancelForm.controls['attendeeId'].patchValue(this.attendeeId);
    this.attCancelForm.controls['userId'].patchValue(this.userId);
    this.attCancelForm.controls['eventId'].patchValue(this.eventId);
    this.attCancelForm.controls['eventUserId'].patchValue(this.eventUserId);
    this.attCancelForm.controls['eventUserIdMain'].patchValue(this.eventUserIdMain);
    this.attCancelForm.controls['payable'].patchValue(val);
    if (this.attCancelForm.dirty && this.attCancelForm.valid) {
      this.ListingService.cancelAttendee(this.attCancelForm.value)
          .subscribe(
              response => {
    		this.spinner = false;
                if(response.status) {
                  this.snackBar.open(response.message, '', {duration: 4000});
                  this.dialogRef.close(response);
                }else {
                  this.spinner = false;
                  this.snackBar.open(response.message, '', {duration: 4000});
                }
          },
              error => {
    		this.spinner = false;
            this.errorMessage = <any>error;
          }
      );
    }
  }

  close() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/cancel-attendee/cancel-attendee.component.ts